import { render, staticRenderFns } from "./approveList.vue?vue&type=template&id=773271c6&scoped=true"
import script from "./approveList.vue?vue&type=script&lang=js"
export * from "./approveList.vue?vue&type=script&lang=js"
import style0 from "./approveList.vue?vue&type=style&index=0&id=773271c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773271c6",
  null
  
)

export default component.exports